import { useState } from "react";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GavelIcon from "@mui/icons-material/Gavel";
import TestPlanViewerDialog from "./TestPlanViewerDialog";

const BUG_VS_FEATURE_GATE_ID = "test-procedure-bug-vs-feature-gate";

const ActiveHillBanner = ({ hill }) => {
  const { palette } = useTheme();
  const [openDocId, setOpenDocId] = useState(null);
  const [openDocTitle, setOpenDocTitle] = useState("");

  const openDoc = ({ docId, docTitle }) => {
    setOpenDocId(docId);
    setOpenDocTitle(docTitle);
  };

  const closeDoc = () => {
    setOpenDocId(null);
    setOpenDocTitle("");
  };

  const testPlanDocId = hill?.testProcedureKnowledgeId || hill?.userScenariosKnowledgeId;

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: palette.backgroundGray.light
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant="caption" color="textSecondary">
          Currently testing
        </Typography>
        <Typography variant="subtitle2">
          {hill.key ? `${hill.key} — ` : ""}
          {hill.title || hill.id}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {testPlanDocId ? (
            <Button
              size="small"
              variant="outlined"
              startIcon={<AssignmentIcon fontSize="small" />}
              onClick={() =>
                openDoc({ docId: testPlanDocId, docTitle: "Test plan" })
              }
            >
              Test plan
            </Button>
          ) : null}
          <Button
            size="small"
            variant="outlined"
            startIcon={<GavelIcon fontSize="small" />}
            onClick={() =>
              openDoc({
                docId: BUG_VS_FEATURE_GATE_ID,
                docTitle: "Bug-vs-feature gate"
              })
            }
          >
            Bug-vs-feature gate
          </Button>
        </Stack>
      </Stack>
      <TestPlanViewerDialog
        open={Boolean(openDocId)}
        docId={openDocId}
        title={openDocTitle}
        onClose={closeDoc}
      />
    </Box>
  );
};

export default ActiveHillBanner;
